import ReactTable from 'react-table';
import styled from 'styled-components';

export const StyledTable = styled(ReactTable)`
  position: relative;
  display: flex;
  flex-direction: column;
  * {
    box-sizing: border-box;
  }
  .rt-table {
    margin: 0 0 20px;
    flex: auto 1;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    border-collapse: collapse;
    overflow: auto;
    border-color: ${({ theme }) => theme.vars.newColor.lightGS1};
    border-style: solid;
    border-width: 1px 1px 0 1px;
  }
  .rt-thead {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    user-select: none;
    &.-headerGroups {
      border-bottom: ${({ theme }) => theme.vars.newColor.lightGS1};
    }
    &.-filters {
      border-bottom: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
      input,
      select {
        border: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
        background: #fff;
        padding: 5px 7px;
        font-size: inherit;
        font-weight: normal;
        outline: none;
      }
    }
    &.-header {
      background-color: ${({ theme }) => theme.vars.newColor.lightGS2};
      border-bottom: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
    }
    .rt-tr {
      text-align: center;
    }
    .rt-th {
      background-color: transparent;
      border: 0;
      display: flex;
      .fa-angle-down {
        visibility: hidden;
        transition: transform 0.25s ease-in-out;
      }
      &.-sort-desc {
        .fa-angle-down {
          visibility: visible;
        }
      }
      &.-sort-asc {
        .fa-angle-down {
          visibility: visible;
          transform: rotate(-180deg);
        }
      }
    }
    .rt-th,
    .rt-td {
      line-height: normal;
      position: relative;
    }
    .rt-th.-cursor-pointer,
    .rt-td.-cursor-pointer {
      cursor: pointer;
    }
    .rt-th:last-child,
    .rt-td:last-child {
      border-right: 0;
    }
    .rt-resizable-header {
      overflow: visible;
      &:last-child {
        overflow: hidden;
      }
    }
    .rt-resizable-header-content {
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: left;
      margin-right: 5px;
      line-height: 19px;
      font-size: 16px;
      color: ${({ theme }) => theme.vars.newColor.darkGS1};
      font-weight: 600;
    }
    .rt-header-pivot {
      border-right-color: ${({ theme }) => theme.vars.newColor.lightGS1};
      &:after,
      &:before {
        left: 100%;
        top: 50%;
        border: solid transparent;
        content: ' ';
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
      }
    }
  }
  .rt-tbody {
    flex: 99999 1 auto;
    display: flex;
    flex-direction: column;
    overflow: auto;
    .rt-tr-group {
      border-bottom: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
      &:hover {
        background-color: ${({ theme }) => theme.vars.newColor.blue4};
      }
    }
    .rt-expandable {
      cursor: pointer;
      text-overflow: clip;
    }
  }
  .rt-tr-group {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  .rt-tr {
    flex: 1 0 auto;
    display: inline-flex;
    &.selected {
      background-color: ${({ theme }) => theme.vars.newColor.lightGS2};
    }
  }
  .rt-th,
  .rt-td {
    padding: 16px 24px;
    flex: 1 0 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    transition: 0.3s ease;
    transition-property: width, min-width, padding, opacity;
  }
  .rt-th.-hidden,
  .rt-td.-hidden {
    width: 0 !important;
    min-width: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    opacity: 0 !important;
  }
  .rt-expander {
    display: inline-block;
    position: relative;
    color: transparent;
    margin: 0 10px;
    &:after {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(-90deg);
      border-left: 5.04px solid transparent;
      border-right: 5.04px solid transparent;
      border-top: 7px solid rgba(0, 0, 0, 0.8);
      transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
      cursor: pointer;
    }
    &.-open:after {
      transform: translate(-50%, -50%) rotate(0);
    }
  }
  .rt-resizer {
    display: inline-block;
    position: absolute;
    width: 36px;
    top: 0;
    bottom: 0;
    right: -18px;
    cursor: col-resize;
    z-index: 10;
  }
  .rt-tfoot {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
  }
  &.-striped .rt-tr.-odd {
    background: rgba(0, 0, 0, 0.03);
  }
  &.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {
    background: rgba(0, 0, 0, 0.05);
  }
  .-pagination {
    z-index: 1;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    flex-wrap: wrap;
    padding: 3px;
    border-top: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
    input,
    select {
      border: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
      background: #fff;
      padding: 5px 7px;
      font-size: inherit;
      font-weight: normal;
      outline: none;
    }
    .-btn {
      appearance: none;
      display: block;
      width: 100%;
      height: 100%;
      border: 0;
      padding: 6px;
      font-size: 1em;
      color: rgba(0, 0, 0, 0.6);
      background: rgba(0, 0, 0, 0.1);
      transition: all 0.1s ease;
      cursor: pointer;
      outline: none;
      &[disabled] {
        opacity: 0.5;
        cursor: default;
      }
      &:not([disabled]):hover {
        background: rgba(0, 0, 0, 0.3);
        color: #fff;
      }
    }
    .-previous,
    .-next {
      flex: 1;
      text-align: center;
    }
    .-center {
      flex: 1.5;
      text-align: center;
      margin-bottom: 0;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-around;
    }
    .-pageInfo {
      display: inline-block;
      margin: 3px 10px;
      white-space: nowrap;
    }
    .-pageJump {
      display: inline-block;
      input {
        width: 70px;
        text-align: center;
      }
    }
    .-pageSizeOptions {
      margin: 3px 10px;
    }
  }
  .rt-noData {
    align-items: center;
    background: ${props => props.theme.vars.newColor.lightGS2};
    color: ${props => props.theme.vars.newColor.black};
    display: flex;
    height: 100%;
    justify-content: center;
    opacity: 0.8;
    padding: 10px;
    position: absolute;
    text-align: center;
    top: 0;
    width: 100%;
  }
  .-loading {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    transition: all 0.3s ease;
    z-index: -1;
    opacity: 0;
    pointer-events: none;
    > div {
      position: absolute;
      display: block;
      text-align: center;
      width: 100%;
      top: 50%;
      left: 0;
      font-size: 15px;
      color: rgba(0, 0, 0, 0.6);
      transform: translateY(-52%);
      transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }
    &.-active {
      opacity: 1;
      z-index: 2;
      pointer-events: all;
      > div {
        transform: translateY(50%);
      }
    }
  }
  .rt-resizing {
    .rt-th,
    .rt-td {
      transition: none !important;
      cursor: col-resize;
      user-select: none;
    }
  }
`;
